function PrivateRoute({children}) {
    
    return children;
}

export {PrivateRoute}